export default {"src":"/_next/static/media/CardiacSurgery.ce38c915.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};